export default function Display({ title = null, children = null }) {
  return (
    <div className="self-stretch rounded-md border border-altgray-200 h-[125px] flex flex-col mb-5 md:w-[260px]">
      <div className="flex text-center items-center bg-altgray-50 font-semibold pt-2.5 pb-1.5 text-[90%] justify-center border-b border-altgray-200 rounded-t-md">
        {title}
      </div>
      <div className="flex flex-row items-center justify-center flex-1 relative">
        {children}
      </div>
    </div>
  );
}


